import { type A7OPCVMComposition, getCompositionsColumns } from "./columns";
import {
  type FilterA7OPCVMCompositionsSchema,
  FilterA7OPCVMCompositions,
} from "./filter";

import { Table } from "@/pages/a7/Table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_compositions";

export const A7OPCVMCompositionsTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getCompositionsColumns(t), [t, i18n.language]);

  return (
    <Table<A7OPCVMComposition, FilterA7OPCVMCompositionsSchema>
      client="a7"
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Compositions",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMCompositions table_name={table_name} />}
    />
  );
};
